import { RoleBasedRoutes } from 'app/config/routes/consts';
import { signOut } from 'processes/auth/helpers/signOut';
import { SidebarMenuLink } from 'widgets/Sidebar/types';

export const SidebarLinks: Array<SidebarMenuLink> = [
	{
		icon: 'search_alt',
		route: RoleBasedRoutes.startRecognition,
	},
	{
		icon: 'custom_model',
		route: RoleBasedRoutes.customModel,
	},
	{
		icon: 'generative_star',
		route: RoleBasedRoutes.generativeModel,
	},
	{
		icon: 'file_dock',
		route: RoleBasedRoutes.files,
	},
	{
		icon: 'notebook',
		route: RoleBasedRoutes.partners,
	},
	{
		icon: 'wallet_alt',
		route: RoleBasedRoutes.subscriptions,
	},
	{
		icon: 'subtasks_alt',
		route: RoleBasedRoutes.extensions,
	},
	{
		icon: 'group_share',
		route: RoleBasedRoutes.coUsers,
	},
	{
		icon: 'group_share',
		route: RoleBasedRoutes.users,
	},
	{
		icon: 'user_circle',
		route: RoleBasedRoutes.personalAccount,
	},
	{
		icon: 'setting_line',
		route: RoleBasedRoutes.integrations,
		list: [
			{
				path: RoleBasedRoutes.integrationsFtpSettings.path,
				access: RoleBasedRoutes.integrationsFtpSettings.access,
			},
			{
				path: RoleBasedRoutes.integrationsPublicApiAccess.path,
				access: RoleBasedRoutes.integrationsPublicApiAccess.access,
			},
		],
	},
	{
		icon: 'chat',
		route: RoleBasedRoutes.support,
		action: () => {
			window.location.href = 'https://retica.ai/documentazione/';
		},
	},
	{
		icon: 'resources',
		route: RoleBasedRoutes.resources,
	},
	{
		icon: 'sign_out_square',
		route: RoleBasedRoutes.signOut,
		action: () => {
			signOut();
		},
	},
];
